<template>
  <CFooter :fixed="false">
    <div>
      <a href="https://www.gfnnet.com" target="_blank">Smart Service Co., Ltd.</a>
      <span class="ml-1">&copy; {{new Date().getFullYear()}} Design.</span>
    </div>
    <div class="mfs-auto">
      <span class="mr-1" target="_blank">Design by</span>
      <a href="https://www.gfnnet.com">Smart Service Co., Ltd.</a>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
